import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../styles/Services.css';
import cq from '../assets/pictures/xray.jpg';

function Services() {
  return (
    <div className="services-page">
      <section className="services-hero">
        <div className="container">
          <h1>
            Nossos <span className="text-highlight">Serviços</span>
          </h1>
          <p>
            Soluções completas em monitoramento radiológico e proteção
            radiológica
          </p>
        </div>
      </section>

      <section className="services-list">
        <div className="container">
          <div className="service-item" id="cq">
            <div className="service-image">
              <img src={cq} alt="Controle de Qualidade" />
            </div>
            <div className="service-content">
              <h2>Controle de Qualidade</h2>
              <p>
                Realizamos todos os testes de controle exigidos pela RDC 611 /
                ANVISA para os equipamentos da sua instituição.
              </p>
              <p>Fazemos o controle de qualidade nos seguintes equipamentos:</p>
              <ul>
                <li>Radio X fixo e móvel</li>
                <li>Radio X Odontológico (Intraoral e Extraoral</li>
                <li>Arco cirúrgico</li>
                <li>Ultrassom</li>
                <li>Mamografia</li>
                <li>Tomografia Computadorizada</li>
                <li>Ressonância Magnética</li>
                {/* <li>Acelerador Linear</li> */}
              </ul>
            </div>
          </div>
          <div className="service-item reverse" id="licensing">
            <div className="service-content">
              <h2>Licenciamento ANVISA/CNEN</h2>
              <p>
                Nós assessoramos seu serviço junto a Vigilância Sanitária e
                Comissão Nacional de Energia Nuclear para obtenção de
                autorização de operação bem como renovação. Atuação em todos os
                níveis, desde projeto de blindagem, até supervisão de
                radioproteção.
              </p>
            </div>
            <div className="service-image">
              <img
                src="/api/placeholder/500/400"
                alt="Monitoramento de Áreas"
              />
            </div>
          </div>
          <div className="service-item" id="tests">
            <div className="service-image">
              <img src="/api/placeholder/500/400" alt="Testes de Aceitação" />
            </div>
            <div className="service-content">
              <h2>Testes de Aceitação</h2>
              <p>
                Executamos todos os testes de aceitação exigidos pela ANVISA e
                CNEN para todos os equipamentos médicos e odontológicos
                emissores de radiação, de acordo com suas portarias e norma
                CNEN-NN-3.05.
              </p>
            </div>
          </div>
          <div className="service-item reverse" id="qa">
            <div className="service-content">
              <h2>Programa de Garantia da Qualidade</h2>
              <p>
                Nosso portal online permite acesso fácil e seguro aos dados de
                dosimetria da sua instituição, proporcionando gestão eficiente
                das informações de exposição radiológica.
              </p>
              <p>Nossos serviços incluem:</p>
              <ul>
                <li>
                  Controle da qualidade de monitores de Laudo e negatoscópios;
                </li>
                <li>Controle de qualidade de detectores (DR,CR e filmes);</li>
                <li>Controle de qualidade de EPIs;</li>
                <li>Controle da dosimetria pessoal mensal e anual</li>
                <li>Projetos de Blindagem</li>
                <li>Assessoria em radioproteção</li>
              </ul>
            </div>
            <div className="service-image">
              <img
                src="/api/placeholder/500/400"
                alt="Programa de Garantia da Qualidade"
              />
            </div>
          </div>
          <div className="service-item" id="tests">
            <div className="service-image">
              <img
                src="/api/placeholder/500/400"
                alt="Treinamento em Radioproteção"
              />
            </div>
            <div className="service-content">
              <h2>Treinamento em Radioproteção</h2>
              <p>
                <ul>
                  <li>Proteção Radiológica em Radiologia;</li>
                  <li>Proteção Radiológica em Odontologia;</li>
                  <li>Atualização em Tomografia Computadorizada;</li>
                  <li>Atualização em Fluoroscopia;</li>
                  <li>Princípios de Formação de Imagem;</li>
                  <li>Atualização em Mamografia Convencional e Digital;</li>
                  <li>Princípios e Formação de Imagem em Ultrassom;</li>
                  <li>Controle de Qualidade em Radiologia;</li>
                  <li>
                    Uso de vestimenta de proteção individual para
                    pacientes,equipe e eventuais acompanhantes;
                  </li>
                  <li>Uso de dosímetros individuais;</li>
                  <li>
                    Procedimentos para minimizar as exposições médicas e
                    ocupacionais;
                  </li>
                  <li>Processamento radiográfico;</li>
                </ul>
              </p>
            </div>
          </div>

          <div className="service-item" id="qa">
            <div className="service-content">
              <h2>Supervisão em Proteção Radiológica</h2>
              <p>
                Nosso portal online permite acesso fácil e seguro aos dados de
                dosimetria da sua instituição, proporcionando gestão eficiente
                das informações de exposição radiológica.
              </p>
              <p>Nossos serviços incluem:</p>
              <ul>
                <li>Levantamento Radiométrico;</li>
                <li>
                  Avaliação contínua dos procedimentos de proteção radiológica
                  na Instalação Radioativa;
                </li>
                <li>Elaboração do Plano de Proteção Radiológica (PPR);</li>
                <li>Interface com a Comissão Nacional de Energia Nuclear.;</li>
                <li>
                  Monitoramento dos equipamentos usados nos procedimentos de
                  proteção radiológica.
                </li>
                <li>
                  Acompanhamento dos procedimentos de proteção radiológica.
                </li>
                <li>
                  Reciclagem do pessoal envolvido com materiais emissores de
                  radiações ionizantes por meio de treinamentos e cursos de
                  atualização.
                </li>
              </ul>
            </div>
            <div className="service-image">
              <img
                src="/api/placeholder/500/400"
                alt="Supervisão em proteção radiológica"
              />
            </div>
          </div>
        </div>
      </section>
      <section className="additional-services">
        <div className="container">
          <h2 className="section-title">Serviços Complementares</h2>

          <div className="service-cards">
            <div className="service-card">
              <div className="service-card-img">
                <img
                  src="/api/placeholder/400/250"
                  alt="Calibração de Equipamentos"
                />
              </div>
              <div className="service-card-content">
                <h3>Calibração de Equipamentos</h3>
                <p>
                  Serviços de calibração para equipamentos de medição
                  radiológica, garantindo precisão e conformidade com normas
                  técnicas.
                </p>
                <a href="#" className="service-card-link">
                  Saiba mais
                </a>
              </div>
            </div>

            <div className="service-card">
              <div className="service-card-img">
                <img src="/api/placeholder/400/250" alt="Treinamentos" />
              </div>
              <div className="service-card-content">
                <h3>Treinamentos</h3>
                <p>
                  Cursos e workshops sobre proteção radiológica, normas
                  regulatórias e boas práticas em ambientes com radiação
                  ionizante.
                </p>
                <a href="#" className="service-card-link">
                  Saiba mais
                </a>
              </div>
            </div>

            <div className="service-card">
              <div className="service-card-img">
                <img
                  src="/api/placeholder/400/250"
                  alt="Testes de Controle de Qualidade"
                />
              </div>
              <div className="service-card-content">
                <h3>Testes de Controle de Qualidade</h3>
                <p>
                  Verificação periódica de equipamentos radiológicos para
                  garantir desempenho ideal e segurança em operações.
                </p>
                <a href="#" className="service-card-link">
                  Saiba mais
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-cta">
        <div className="container">
          <h2>Não encontrou o que procura?</h2>
          <p>
            Entre em contato com nossa equipe para discutir soluções
            personalizadas que atendam às necessidades específicas da sua
            instituição.
          </p>
          <a href="/contact" className="btn btn-primary">
            Fale com um Especialista
          </a>
        </div>
      </section>
    </div>
  );
}

export default Services;
